module.exports = __webpack_public_path__ + "static/media/dashboardHistory_fr.7cabe410.png";